import React, { useEffect } from 'react'
import Logo from '../assets/MainLogo/Gold/ThirdLineMainLogoGold.svg'
import PropTypes from 'prop-types'
import Navbar from './navbar'
import Sidebar from './sidebar.jsx'
import { ToastContainer } from 'react-toastify'
import 'react-toastify/dist/ReactToastify.css'
import EnhancedErrorBoundary from '../shared/enhanced-error-boundary'
import { SidebarProvider, useSidebar } from './sidebar-context'

function PageShell({ title, subtitle, pageTitle, navActions, children }) {
  const { isCollapsed } = useSidebar()

  useEffect(() => {
    document.title = pageTitle || (typeof title === 'string' ? title : '')
  }, [title, pageTitle])

  return (
    <div
      style={{ backgroundColor: '#f5f5f5' }}
      className={`vh-100 app-shell ${isCollapsed ? 'app-shell-collapsed' : ''}`}
    >
      <div className="container-fluid me-1">
        <ToastContainer position="top-right" />
        <Navbar logo={Logo} title={title} subtitle={subtitle} navActions={navActions} />
        <Sidebar />
        <div className="d-flex flex-column flex-shrink-0 p-3 px-md-4 app-main-content">
          <main role="main">
            <EnhancedErrorBoundary>
              {children}
            </EnhancedErrorBoundary>
          </main>
        </div>
      </div>
    </div>
  )
}

PageShell.propTypes = {
  title: PropTypes.any.isRequired,
  subtitle: PropTypes.node,
  pageTitle: PropTypes.string,
  navActions: PropTypes.node,
  children: PropTypes.node.isRequired
}

function Page(props) {
  return (
    <SidebarProvider>
      <PageShell {...props} />
    </SidebarProvider>
  )
}

Page.propTypes = {
  title: PropTypes.any.isRequired,
  subtitle: PropTypes.node,
  pageTitle: PropTypes.string,
  navActions: PropTypes.node,
  children: PropTypes.node.isRequired
}

export default Page
